import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dealIcon_chart",
  "use": "icon-dealIcon_chart-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-dealIcon_chart\"><g stroke=\"#1989FA\"><rect x=\"1.5\" y=\"7.5\" width=\"3\" height=\"6\" rx=\"1\" /><rect x=\"6.5\" y=\"1.5\" width=\"3\" height=\"12\" rx=\"1\" /><path d=\"M14 5.5l.5 7.5-2.5.5-.5-7.498L14 5.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol